import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { en } from './locales/en';
import { si } from './locales/si';

export const LANGUAGES = [
  { code: 'en', label: 'English', nativeLabel: 'English' },
  { code: 'si', label: 'Sinhala', nativeLabel: 'සිංහල' },
] as const;

export type LanguageCode = (typeof LANGUAGES)[number]['code'];

const STORAGE_KEY = 'tharanga.language';

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      si: { translation: si },
    },
    fallbackLng: 'en',
    supportedLngs: LANGUAGES.map((language) => language.code),
    // Without this, a browser reporting "si-LK" would miss the "si" bundle.
    nonExplicitSupportedLngs: true,
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: STORAGE_KEY,
      caches: ['localStorage'],
    },
    interpolation: {
      // React escapes for us; double-escaping mangles anything with an ampersand.
      escapeValue: false,
    },
    returnNull: false,
  });

/**
 * Keeps `<html lang>` in step with the active language. The CSS in index.css
 * hangs Sinhala's extra line-height off that attribute, so this is what makes
 * the typography adjust rather than just the words.
 */
function applyDocumentLanguage(language: string): void {
  document.documentElement.lang = language.startsWith('si') ? 'si' : 'en';
}

applyDocumentLanguage(i18n.language);
i18n.on('languageChanged', applyDocumentLanguage);

export function changeLanguage(code: LanguageCode): void {
  void i18n.changeLanguage(code);
}

export function currentLanguage(): LanguageCode {
  return i18n.language.startsWith('si') ? 'si' : 'en';
}

export default i18n;
